/* eslint-disable react/prop-types */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import moment from 'moment';
import { Row, Col, Button, Select, DatePicker, Icon, Spin } from 'antd';
const { Option } = Select;
const { RangePicker } = DatePicker;

import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
  Legend,
  Label
} from 'recharts';

import {
  ssrHandler,
  fetchActiveReportsMetaData,
  fetchCP,
  fetchTrackingDelay,
  resetCPs,
  fetchServiceMetaData,
  fetchTrackingDelayPercentile
} from '../actions/sessionActions';
import { generateMonthList } from '../utils/assetUtils';

const antIcon = <Icon type="loading" style={{ fontSize: 80 }} spin />;

const CustomTooltip = ({ active, payload, label, isPercentile }) => {
  if (active) {
    return (
      <div className="custom-tooltip">
        <h3 className="datetime">{label}</h3>
        <table>
          <thead>
            <tr>
              <th>Courier Partner</th>
              <th>
                {isPercentile ? '' : 'Average '}
                Lag(mins)
              </th>
              <th>Total Shipment</th>
            </tr>
          </thead>
          <tbody>
            {payload.map((item, i) => (
              <tr key={i}>
                <td>
                  <span
                    style={{
                      backgroundColor: item.stroke,
                      width: 12,
                      height: 12,
                      display: 'inline-block',
                      marginRight: 5
                    }}
                  />
                  {item.name}
                </td>
                <td>{item.value}</td>
                <td>{item.payload.totalShipments[item.name]}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }
  return null;
};

const percentileList = [
  { label: '99 Percentile', value: 99 },
  { label: '95 Percentile', value: 95 },
  { label: '90 Percentile', value: 90 },
  { label: '85 Percentile', value: 85 },
  { label: '80 Percentile', value: 80 },
  { label: '75 Percentile', value: 75 }
];

export class TrackingDelay extends Component {
  static async fetchData({ dispatch }, match, route) {
    await dispatch(ssrHandler(route.path));
    // await dispatch(fetchCp());
  }
  constructor() {
    super();
    this.state = {
      filter: {
        enterpriseId: null,
        cps: [],
        startDate: '',
        endDate: '',
        percentile: [99]
      },
      enterpriseId: null,
      months: null,
      serviceType: null,
      defaultMonths: generateMonthList(3).map(month => month.value)
    };
  }

  componentDidMount() {
    const { filter } = this.state;
    this.props.fetchActiveReportsMetaData('enterprise');
    this.props.fetchServiceMetaData();
    this.props.fetchTrackingDelay(filter);
    this.props.fetchTrackingDelayPercentile(filter);
  }

  reset = () => {
    let { filter } = this.state;
    filter = {
      enterpriseId: null,
      cps: [],
      startDate: '',
      endDate: '',
      percentile: 99
    };
    this.setState({ filter });
    this.props.resetCPs();
    this.props.fetchTrackingDelay(filter);
    this.props.fetchServiceMetaData();
    this.props.fetchTrackingDelayPercentile(filter);
  };

  handleChange = (key, value) => {
    const { filter } = this.state;
    filter[key] = value;
    if (key === 'percentile') {
      this.props.fetchTrackingDelayPercentile(filter);
    } else if (key === 'enterpriseId') {
      filter.cps = [];
      if (value) {
        this.props.fetchCP(value);
      } else {
        this.props.resetCPs();
      }
    }
    this.setState({ filter });
  };

  handleSearch = () => {
    const { filter } = this.state;
    this.props.fetchTrackingDelay(filter);
    this.props.fetchTrackingDelayPercentile(filter);
  };

  onRangeChange = (date, dateString) => {
    const { filter } = this.state;
    filter.startDate = dateString[0];
    filter.endDate = dateString[1];
    this.setState({ filter });
  };

  disabledDate = current => {
    return (
      moment().add(-1, 'days') >= current || moment().add(1, 'month') <= current
    );
  };

  render() {
    const { metadata } = this.props;
    return (
      <div>
        <Row className="margin-bottom-10 view-header">
          <Col span={5}>
            <div className="global-search-wrapper" style={{ width: '100%' }}>
              <Select
                name="enterpriseId"
                id="enterpriseId"
                // ref={ref => (this.enterpriseId = ref)}
                showSearch
                style={{ width: '96%' }}
                placeholder="Select Enterprise"
                optionFilterProp="children"
                value={
                  this.state.filter.enterpriseId
                    ? this.state.filter.enterpriseId
                    : undefined
                }
                onChange={value => this.handleChange('enterpriseId', value)}
                allowClear={true}
                filterOption={(input, option) =>
                  option.props.children
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
              >
                {metadata.enterprise.list.map((enterprise, i) => (
                  <Option key={i} value={enterprise.id}>
                    {enterprise.name}
                  </Option>
                ))}
              </Select>
            </div>
          </Col>
          <Col span={11}>
            <div className="global-search-wrapper" style={{ width: '100%' }}>
              <Select
                placeholder="Please select courier partner"
                value={
                  this.state.filter.cps.length > 0
                    ? this.state.filter.cps
                    : undefined
                }
                mode="multiple"
                style={{ width: '96%' }}
                onChange={value => this.handleChange('cps', value)}
                filterOption={(input, option) =>
                  option.props.children
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
              >
                {metadata.cp.list.map((cp, i) => (
                  <Option key={i} value={cp.id}>
                    {cp.name}
                  </Option>
                ))}
              </Select>
            </div>
          </Col>
          <Col span={5}>
            <div className="global-search-wrapper" style={{ width: '96%' }}>
              <RangePicker
                onChange={this.onRangeChange}
                // disabledDate={this.disabledDate}
              />
            </div>
          </Col>
          <Col span={3} className="text-center">
            <Button
              type="primary"
              className="pull-left"
              onClick={this.handleSearch}
            >
              Submit
            </Button>
            <Button type="primary" onClick={this.reset} className="pull-right">
              Reset
            </Button>
          </Col>
        </Row>
        <Row>
          <Col span={24} className="margin-bottom-10">
            {this.props.trackingDelay.isFetching ? (
              <div
                className="text-center spinner-container"
                style={{ height: '300px' }}
              >
                <Spin indicator={antIcon} />
              </div>
            ) : this.props.trackingDelay.list.length > 0 ? (
              <LineChart
                width={1200}
                height={300}
                data={this.props.trackingDelay.list}
                margin={{ top: 5, right: 5, left: 5, bottom: 5 }}
              >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="date">
                  <Label
                    value="Overall Stats"
                    offset={0}
                    position="insideBottom"
                  />
                </XAxis>
                <YAxis
                  label={{
                    value: 'Average Lag(mins)',
                    angle: -90,
                    position: 'insideLeft'
                  }}
                />
                <Tooltip content={<CustomTooltip />} />
                <Legend verticalAlign="top" height={36} />
                {this.props.trackingDelay.legends.map((legend, i) => (
                  <Line
                    key={legend}
                    type="monotone"
                    dataKey={legend}
                    dot={{ strokeWidth: 2 }}
                    strokeWidth={2}
                    stroke={this.props.trackingDelay.colors[i]}
                  />
                ))}
              </LineChart>
            ) : (
              <div>&nbsp; No Data</div>
            )}
          </Col>
          <Col span={24} className="margin-bottom-10">
            <Row className="view-header">
              <Col span={5}>
                <div
                  className="global-search-wrapper"
                  style={{ width: '100%' }}
                >
                  <Select
                    name="percentile"
                    id="percentile"
                    showSearch
                    style={{ width: '96%' }}
                    placeholder="Select Percentile"
                    optionFilterProp="children"
                    value={
                      this.state.filter.percentile
                        ? this.state.filter.percentile
                        : undefined
                    }
                    onChange={value => this.handleChange('percentile', value)}
                    allowClear={true}
                    filterOption={(input, option) =>
                      option.props.children
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                    }
                  >
                    {percentileList.map((percentile, i) => (
                      <Option key={i} value={percentile.value}>
                        {percentile.label}
                      </Option>
                    ))}
                  </Select>
                </div>
              </Col>
            </Row>
          </Col>
          <Col span={24} className="margin-bottom-10">
            {this.props.trackingDelay.percentile.isFetching ? (
              <div
                className="text-center spinner-container"
                style={{ height: '300px' }}
              >
                <Spin indicator={antIcon} />
              </div>
            ) : this.props.trackingDelay.percentile.list.length > 0 ? (
              <LineChart
                width={1200}
                height={300}
                data={this.props.trackingDelay.percentile.list}
                margin={{ top: 5, right: 5, left: 5, bottom: 5 }}
              >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="date">
                  <Label
                    value="Percentile Stats"
                    offset={0}
                    position="insideBottom"
                  />
                </XAxis>
                <YAxis
                  label={{
                    value: 'Lag(mins)',
                    angle: -90,
                    position: 'insideLeft'
                  }}
                />
                <Tooltip content={<CustomTooltip isPercentile={true} />} />
                <Legend verticalAlign="top" height={36} />
                {this.props.trackingDelay.percentile.legends.map(
                  (legend, i) => (
                    <Line
                      key={legend}
                      type="monotone"
                      dataKey={legend}
                      dot={{ strokeWidth: 2 }}
                      strokeWidth={2}
                      stroke={this.props.trackingDelay.colors[i]}
                    />
                  )
                )}
              </LineChart>
            ) : (
              <div>&nbsp; No Data</div>
            )}
          </Col>
        </Row>
      </div>
    );
  }
}

TrackingDelay.propTypes = {
  config: PropTypes.object,
  metadata: PropTypes.object,
  billing: PropTypes.object,
  trackingDelay: PropTypes.object,
  match: PropTypes.object,
  fetchActiveReportsMetaData: PropTypes.func,
  fetchCP: PropTypes.func,
  fetchTrackingDelay: PropTypes.func,
  resetCPs: PropTypes.func,
  fetchServiceMetaData: PropTypes.func,
  fetchTrackingDelayPercentile: PropTypes.func
};

TrackingDelay.contextTypes = {
  router: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
  config: state.session.config,
  metadata: state.session.metadata,
  billing: state.session.billing,
  trackingDelay: state.session.trackingDelay
});

const mapDispatchToProps = dispatch => ({
  fetchActiveReportsMetaData: data =>
    dispatch(fetchActiveReportsMetaData(data)),
  fetchCP: query => dispatch(fetchCP(query)),
  fetchTrackingDelay: query => dispatch(fetchTrackingDelay(query)),
  resetCPs: () => dispatch(resetCPs()),
  fetchServiceMetaData: () => dispatch(fetchServiceMetaData()),
  fetchTrackingDelayPercentile: query =>
    dispatch(fetchTrackingDelayPercentile(query))
});

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(TrackingDelay)
);
